<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">
  <button mat-raised-button class="responsive-table-desktop" color="primary" (click)="goToAddCall()">
    <mat-icon>add_circle</mat-icon> Adicionar Chamado
  </button>

  <p class="no-margin"><b>Selecione os Status abaixo</b></p>

  <mat-form-field class="full-width">
    <mat-chip-list #chipList aria-label="Status selection">
      <mat-chip
        *ngFor="let status of statusSelection"
        [removable]="true"
        (removed)="removeStatus(status)"
        color="primary"
        selected
      >
        {{status.name}}
        <mat-icon *ngIf="!status.default" matChipRemove>cancel</mat-icon>
      </mat-chip>

      <mat-select
        [(ngModel)]="statusCurrent"
        (valueChange)="addStatusToSelection($event)"
      >
        <mat-option value="A">Abertos</mat-option>
        <mat-option value="T">Em Atendimento</mat-option>
        <mat-option value="P">Pendente</mat-option>
        <mat-option value="R">Resolvido</mat-option>
        <mat-option value="F">Fechado</mat-option>
        <mat-option value="C">Cancelado</mat-option>
      </mat-select>
    </mat-chip-list>
  </mat-form-field>

  <app-filter-call class="full-width"
    (search)="search($event)"
  ></app-filter-call>

  <app-list-call-item-operator  class="full-width responsive-table-desktop"
    [calls]="calls"
  ></app-list-call-item-operator>

  <app-list-call-item-responsive class="full-width responsive-table-mobile"
    [calls]="calls"
  ></app-list-call-item-responsive>

  <div *ngIf="isLoading" fxFill fxLayoutAlign="center center">
    <mat-spinner diameter="30"></mat-spinner>
  </div>

  <mat-paginator
    fxFill
    class="responsive-paginator"
    itemsPerPageLabel="Items por página"
    [length]="length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="setPage = $event"
  >
  </mat-paginator>

  <div class="fab-button responsive-table-mobile">
    <button mat-fab color="primary" (click)="goToAddCall()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
